import * as React from "react";
import { GroupBy } from "../types";
import { getMonitoringCounts, getInsightsCount, getSnoozedCount } from "..";

export const useCounts = (
  group: GroupBy,
  grouped: Insite.Insights.ComposedOccurrence[][],
  composedGrouped: Insite.Insights.ComposedInsight[][],
  showSnoozed: boolean
) => {
  const [siteCount, setSiteCount] = React.useState(0);
  const [equipCount, setEquipCount] = React.useState(0);
  const [insightsCount, setInsightsCount] = React.useState(0);
  const [snoozedCount, setSnoozedCount] = React.useState(0);

  React.useEffect(() => {
    const { siteCount: sites, equipCount: equips } = getMonitoringCounts(
      group,
      grouped,
      showSnoozed
    );
    setSiteCount(sites);
    setEquipCount(equips);
  }, [group, grouped, showSnoozed]);

  React.useEffect(() => {
    setInsightsCount(getInsightsCount(composedGrouped, showSnoozed));
    setSnoozedCount(getSnoozedCount(composedGrouped));
  }, [composedGrouped, showSnoozed]);

  return {
    siteCount,
    equipCount,
    insightsCount,
    snoozedCount,
  };
};
